import { ArcLinkLabel } from './ArcLinkLabel'

export const ArcLinkLabelComponent = ArcLinkLabel
export * from './ArcLinkLabelsLayer'
export * from './canvas'
export * from './compute'
export * from './props'
export * from './types'
export * from './useArcLinkLabels'
export * from './useArcLinkLabelsTransition'
export * from './useArcLinks'
